import React from 'react'
import compucar from '../Assets/compucar.png'
import './Header.css'

const Header = () => {
  return (
    <div className="Header">
        <img src={compucar} alt=""></img>
    </div>
  )
}

export default Header